import { SupportedChainId } from '~/constants/chains'
import { IAddress } from '~/types'
import { captureException } from '~/utils/errors'
import { retryExponentialBackoff } from '~/utils/requests'

/**
 * Fetches token price from Relay API
 * @param address - Token address
 * @param chainId - Chain ID
 * @returns Price as a number, or undefined if the request fails
 */
export const fetchRelayPrice = async (
  address: IAddress,
  chainId: SupportedChainId,
): Promise<number | undefined> => {
  try {
    const response = await retryExponentialBackoff(
      fetch,
      [
        `https://api.relay.link/currencies/token/price?address=${address}&chainId=${chainId}`,
      ],
      {
        maxTry: 3,
      },
    )

    if (!response.ok) {
      if (response.status === 400) {
        // No price found for token
        return undefined
      }

      captureException(new Error('Failed to fetch relay price'), {
        extra: {
          address,
          chainId,
          status: response.status,
        },
      })
    }

    const data = (await response.json()) as { price: number }
    return data.price
  } catch (error) {
    captureException(error, {
      extra: {
        address,
        chainId,
      },
    })
    return undefined
  }
}
